import { all, call, fork, takeEvery } from "redux-saga/effects";
import requestFunction from "../../Utils/sagaGenericFunction";
import {
  getUserWalletSuccess,
  getUserWalletFailure,
  createFundingIntentSuccess,
  createFundingIntentFailure,
  initializeFundingPaymentSuccess,
  initializeFundingPaymentFailure,
  verifyFundingPaymentSuccess,
  verifyFundingPaymentFailure,
  getWalletHistorySuccess,
  getWalletHistoryFailure,
} from "../Actions/walletAction";
import {
  GET_USER_WALLET,
  CREATE_FUNDING_INTENT,
  INITIALIZE_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT,
  GET_WALLET_HISTORY,
} from "../ActionTypes";
import {
  GetUserWalletApi,
  CreateFundingIntentApi,
  InitializeFundingPaymentApi,
  VerifyFundingPaymentApi,
  GetWalletHistoryApi,
} from "../Api"; // This now imports correctly from your new structure

const getUserWalletWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getUserWalletSuccess,
    getUserWalletFailure,
    GetUserWalletApi,
    payload,
  );
};
const createFundingIntentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    createFundingIntentSuccess,
    createFundingIntentFailure,
    CreateFundingIntentApi,
    payload,
  );
};

const initializeFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    initializeFundingPaymentSuccess,
    initializeFundingPaymentFailure,
    InitializeFundingPaymentApi,
    payload,
  );
};

const verifyFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    verifyFundingPaymentSuccess,
    verifyFundingPaymentFailure,
    VerifyFundingPaymentApi,
    payload,
  );
};

const getWalletHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getWalletHistorySuccess,
    getWalletHistoryFailure,
    GetWalletHistoryApi,
    payload,
  );
};

export const getUserWalletWatcher = function* () {
  yield takeEvery(GET_USER_WALLET, getUserWalletWorker);
};
export const fundingSagas = function* () {
  yield takeEvery(CREATE_FUNDING_INTENT, createFundingIntentWorker);
  yield takeEvery(INITIALIZE_FUNDING_PAYMENT, initializeFundingPaymentWorker);
  yield takeEvery(VERIFY_FUNDING_PAYMENT, verifyFundingPaymentWorker);
};
export const walletHistorySaga = function* () {
  yield takeEvery(GET_WALLET_HISTORY, getWalletHistoryWorker);
};

export default function* walletSaga() {
  yield all([
    fork(getUserWalletWatcher),
    fork(fundingSagas),
    fork(walletHistorySaga),
  ]);
}
